/* eslint-disable */
/* tslint:disable */

/** deleteJob
 * method: delete
 * summary: Delete one job from the hubler profile
 */

import type { ApiResponseDto } from './../api-types'

export const getPath = (idJob: number): string =>
  `/bff-worker/profile/jobs/${idJob}`
export const getFullPath = (idJob: number): string =>
  `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/profile/jobs/${idJob}`

export type DeleteJobSuccess = never
export type DeleteJobError = ApiResponseDto
